export const hasNameChanged = (formValues, currentValues) => {
  return (
    formValues.lastName.toLowerCase() !== currentValues.lastName.toLowerCase() ||
    formValues.firstName.toLowerCase() !== currentValues.firstName.toLowerCase() ||
    (formValues.middleName.toLowerCase() !== currentValues.middleName.toLowerCase() &&
      formValues.noMiddle)
  );
};

export const hasFioFieldsChanged = (formValue) => {
  return (
    formValue.firstName ||
    formValue.lastName ||
    formValue.middleName ||
    formValue.prevFirstName ||
    formValue.prevLastName ||
    formValue.prevMiddleName
  );
};

export const formatFioToUpperCase = (formValue) => {
  if (formValue.fullName) {
    formValue.fullName = formValue.fullName.toUpperCase();
  }

  if (formValue.firstName) {
    formValue.firstName = formValue.firstName.toUpperCase();
  }

  if (formValue.lastName) {
    formValue.lastName = formValue.lastName.toUpperCase();
  }

  if (formValue.middleName) {
    formValue.middleName = formValue.middleName.toUpperCase();
  }

  return formValue;
};

export const formatPrevFioToUpperCase = (formValue) => {
  if (formValue.prevFullName) {
    formValue.prevFullName = formValue.prevFullName.toUpperCase();
  }

  if (formValue.prevFirstName) {
    formValue.prevFirstName = formValue.prevFirstName.toUpperCase();
  }

  if (formValue.prevLastName) {
    formValue.prevLastName = formValue.prevLastName.toUpperCase();
  }

  if (formValue.prevMiddleName) {
    formValue.prevMiddleName = formValue.prevMiddleName.toUpperCase();
  }

  return formValue;
};
